// Photos ALLÉGÉES avant l'envoi : une photo de téléphone pèse 3 à 8 Mo pour
// 4000 px de large. Ramenée à 2000 px en JPEG, elle reste nette à l'écran et
// part en quelques secondes en 4G.
//
// Si le navigateur ne sait pas décoder le format (HEIC sur un ordinateur, par
// exemple), la photo part telle quelle : mieux vaut lourde que perdue.

const MAX_SIDE = 2000;
const QUALITY = 0.85;

export async function shrinkPhoto(file: File): Promise<File> {
  if (!file.type.startsWith('image/') || file.type === 'image/gif') return file;
  try {
    // `from-image` : la photo prise téléphone tourné reste dans le bon sens.
    const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
    const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
    if (scale === 1 && file.size < 1.5 * 1024 * 1024) {
      bitmap.close();
      return file;
    }
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext('2d')?.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close();
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', QUALITY));
    if (!blob || blob.size >= file.size) return file;
    const name = file.name.replace(/\.[^.]+$/, '') || 'photo';
    return new File([blob], `${name}.jpg`, { type: 'image/jpeg', lastModified: file.lastModified });
  } catch {
    return file;
  }
}
